import Heading from '@/components/Heading/Heading'
import { type IClause, type ILaw, type INode } from '@/lib/ris-types'
import { type FunctionComponent } from 'react'
import Inline from '../Inline/Inline'
import * as styles from './Title.css'
import { HoverOptions } from './Title.client'

const Title: FunctionComponent<INode & { index: number, clause: IClause, norm?: ILaw }> = function ({ index, norm, clause, ...child }) {
  // @ts-expect-error norm is only typed as ILaw currently, but it can also be a decision
  if (norm?.institution === 'BFG') {
    return (
      <Heading h={3}>
        <Inline {...child} />
      </Heading>
    )
  }

  function ClauseTitle ({ empty = false }: { empty?: boolean }) {
    if (norm === undefined) {
      return (
        <Heading h={4}>
          <span>{clause.enumeration}</span>
          <Inline {...child} />
        </Heading>
      )
    }

    return (
      <HoverOptions
        enumeration={clause.enumeration}
        norm={norm}
        counts={clause.counts}
      >
        <Heading h={4}>
          {clause.enumeration}&ensp;{!empty && <Inline {...child} />}
        </Heading>
      </HoverOptions>
    )
  }

  if (child.type === 'ueberschrift.para' || child.type === 'ueberschrift.titel') {
    return <ClauseTitle />
  }
  return (
    <>
      <Heading h={4} className={styles.typeSection}>
        <Inline {...child} />
      </Heading>
      {/* Sometimes the clause has no para title but other ueberschriften. In that case use the last section ueberschrift to also render the clause title */}
      {!clause.title && !clause.children?.[index + 1]?.type?.startsWith('ueberschrift') && (
        // Render it with no content, othewise it will render the section title text twice
        // Reproduction example: http://localhost:3000/bundesrecht/bundesgesetze/asvg#anl-1 or https://dev.gesetzefinden.at/bundesrecht/bundesgesetze/abgb#para-39
        <ClauseTitle empty />
      )}
    </>
  )
}

export default Title
